import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import history from '../../history';
import cx from 'classnames';
// external-global styles must be imported in your JS.
import normalizeCss from 'normalize.css';
import SideMenu from '../SideMenu/SideMenu';
import AdminHeader from '../AdminHeader/AdminHeader';
import Toaster from '../Toaster';
import OffcanvasMenu from '../SideMenu/MobileSideBar/OffcanvasMenu';
import s from './AdminLayout.css';

function AdminLayout({ children }) {

  // For Highlighting Side Menu based on URL
  const location = history.location?.pathname;

  return (
    <div className="bodyOverflow rtlLoader">
      {/* A11Y (WCAG 2.1 AA 2.4.1 Bypass Blocks): skip-to-content link, visually
          hidden until keyboard-focused, jumps past the admin header + side nav
          to <main>. Mirrors the public Layout. */}
      <a href="#main-content" className={s.skipLink}>Skip to main content</a>
      <Toaster />
      <AdminHeader />
      <aside className={cx(s.sideMenuContainer, "hidden-print")}>
        <div className={cx(s.sideMenuWrapper, 'sideMenuWrapperRtl')}>
          <SideMenu location={location} />
        </div>
      </aside>
      <OffcanvasMenu location={location} />
      <main id="main-content" className={cx(s.mainContent, 'mainContentRTL', 'printBody')}>
        {children}
      </main>
    </div>
  );
}

AdminLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default withStyles(normalizeCss, s)(AdminLayout);
